module.exports = __webpack_public_path__ + "img/accIcon.bf6e0def.svg";